import { render, staticRenderFns } from "./OrderListView.vue?vue&type=template&id=39ba66aa&scoped=true"
import script from "./OrderListView.vue?vue&type=script&lang=js"
export * from "./OrderListView.vue?vue&type=script&lang=js"
import style0 from "./OrderListView.vue?vue&type=style&index=0&id=39ba66aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba66aa",
  null
  
)

export default component.exports